import { ConfigDto, SampleDetailsDto } from '@src/types/types.ts';
import { AnySection } from '@src/asbestos/components/AnySection.tsx';
import { AsbestosTargetType } from '@src/asbestos/types.ts';

export const KmfSection = ({
  sample,
  configuration,
  onInfoTap,
}: {
  sample: SampleDetailsDto;
  configuration: ConfigDto;
  onInfoTap: () => void;
}) => {
  return (
    <AnySection
      sample={sample}
      configuration={configuration}
      onInfoTap={onInfoTap}
      targetType={AsbestosTargetType.KMF}
    />
  );
};
